import React from 'react';

import {
  EditDeleteButtonGroup,
  GridTableRow,
} from '../../../../../../../shared/components/table-components';
import {
  CorporateAccount,
  CorporateAccountFormValues,
} from '../../../../../../interfaces/CorporateAccount';

type CorporateAccountsTableRowProps = {
  account: CorporateAccount;
  openModal: (accountData: CorporateAccountFormValues, id: number) => void;
  deleteAccount: (id: number) => void;
};

const CorporateAccountsTableRow = ({
  account,
  openModal,
  deleteAccount,
}: CorporateAccountsTableRowProps) => {
  const { id, login, password } = account;
  const hiddenPassword = password.replace(/./g, '●');

  const handleDelete = () => {
    deleteAccount(id);
  };

  const handleOpenEditModal = (accountData: CorporateAccountFormValues) => () => {
    openModal(accountData, id);
  };

  return (
    <GridTableRow variant="row" key={id}>
      <span className="private-info">{login}</span>
      <span>{hiddenPassword}</span>
      <EditDeleteButtonGroup
        onEdit={handleOpenEditModal({ login, password })}
        onDelete={handleDelete}
        modalTitle="Are you sure you want to delete corporate account?"
      />
    </GridTableRow>
  );
};

export { CorporateAccountsTableRow };
